import PropTypes from 'prop-types';
import classnames from 'classnames';

import Gallery from 'dibs-icons/exports/Gallery';
import ArtworkFrame from 'dibs-icons/exports/ArtworkFrame';
import PlayButtonInverse from 'dibs-icons/exports/PlayButtonInverse';

import styles from './PdpSharedHeroCarouselThumb.scss';

export const PdpSharedHeroCarouselThumb = props => {
    const {
        index,
        isCurrentItem,
        isClient,
        isRoomView,
        thumbs,
        totalItems,
        size,
        onIndexChange,
        isRequestMoreImagesEnabled,
        isVideo,
    } = props;
    const { srcSet, src, alt } = thumbs[index] || {};
    const position = index + 1;
    const isCarouselLastItem = position === totalItems;
    const isRequestMoreImages = isCarouselLastItem && isRequestMoreImagesEnabled;

    let icon;
    let overlay;

    const img = isClient && (
        <img
            className={styles.thumb}
            src={src}
            alt={alt}
            srcSet={srcSet}
            data-tn="pdp-hero-carousel-image-thumb"
        />
    );

    if (isRequestMoreImages) {
        icon = <Gallery className={styles.icon} />;
    }

    if (isRoomView) {
        overlay = (
            <span className={styles.frameOverlay}>
                <ArtworkFrame className={styles.icon} />
            </span>
        );
    }
    if (isVideo) {
        overlay = (
            <span className={styles.playIconOverlay}>
                <PlayButtonInverse className={styles.playIcon} />
            </span>
        );
    }

    const wrapperClasses = classnames(styles.wrapper, {
        [styles.isCurrent]: isCurrentItem && isClient,
        [styles.iconWrapper]: icon,
        [styles.placeholder]: !isClient,
        [styles.small]: size === 'small',
    });

    return (
        <div className={wrapperClasses} onClick={() => onIndexChange({ index })}>
            {icon || img}
            {overlay}
        </div>
    );
};

PdpSharedHeroCarouselThumb.propTypes = {
    index: PropTypes.number.isRequired,
    isCurrentItem: PropTypes.bool,
    isVideo: PropTypes.bool,
    isClient: PropTypes.bool,
    isRoomView: PropTypes.bool,
    thumbs: PropTypes.array.isRequired,
    size: PropTypes.string,
    totalItems: PropTypes.number.isRequired,
    onIndexChange: PropTypes.func,
    isRequestMoreImagesEnabled: PropTypes.bool,
};
